import React, { useState, useEffect } from 'react';
import GenericModal from '@ui-components/Modal/GenericModal';
import GenericButton from '@ui-components/Button/GenericButton';
import GenericInput from '@ui-components/Input/GenericInput';
import type { FortiFlexAccountLabel } from '../hooks/useFortiFlexData';

interface AccountLabelFormModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (data: { accountId: string; label: string }) => void;
    account?: FortiFlexAccountLabel | null;
    loading?: boolean;
}

const AccountLabelFormModal: React.FC<AccountLabelFormModalProps> = ({
    isOpen,
    onClose,
    onSubmit,
    account,
    loading,
}) => {
    const [accountId, setAccountId] = useState('');
    const [label, setLabel] = useState('');
    const isEdit = Boolean(account);

    useEffect(() => {
        if (account) {
            setAccountId(account.accountId);
            setLabel(account.label);
        } else {
            setAccountId('');
            setLabel('');
        }
    }, [account, isOpen]);

    return (
        <GenericModal
            isOpen={isOpen}
            onClose={onClose}
            title={isEdit ? 'Edit Account Label' : 'Add Account Label'}
            size="sm"
            footer={
                <>
                    <GenericButton
                        variant="secondary"
                        size="md"
                        label="Cancel"
                        onClick={onClose}
                    />
                    <GenericButton
                        variant="brand"
                        size="md"
                        label={loading ? 'Saving...' : isEdit ? 'Update' : 'Create'}
                        onClick={() => onSubmit({ accountId, label })}
                        disabled={loading || !accountId || !label}
                        loading={loading}
                    />
                </>
            }
        >
            <div className="space-y-4">
                <GenericInput
                    label="Account ID"
                    value={accountId}
                    onChange={setAccountId}
                    disabled={isEdit}
                    readOnly={isEdit}
                />
                <GenericInput
                    label="Label"
                    value={label}
                    onChange={setLabel}
                    placeholder="Human-readable label for this account"
                />
            </div>
        </GenericModal>
    );
};

export default AccountLabelFormModal;
